import React from "react";
import { Fade } from "react-awesome-reveal";
import Header from "parts/Header2";
import Discuss from "parts/Discuss2";
import Footer from "parts/Footer2";
import AME from "assets/images/customers/AME2.png";
import ATIE from "assets/images/customers/ATIE2.png";
import ECAA from "assets/images/customers/ECAA2.png";
import GFIP from "assets/images/customers/GFIP2.png";
import HIAP from "assets/images/customers/HIAP2.png";
import HIH from "assets/images/customers/HIH2.png";
import JTP from "assets/images/customers/JTP2.png";
import LAPTP from "assets/images/customers/LAPTP2.png";
import NCL from "assets/images/customers/NCL2.png";
import SIP from "assets/images/customers/SIP2.png";
import STP from "assets/images/customers/STP2.png";
import ZMH from "assets/images/customers/ZMH2.jpeg";

export default function Customers() {
  return (
    <>
      <Header />
      <section className="min-h-screen text-gray-800 py-16 px-4 md:px-10">
        {/* Title */}
        <div className="text-center mb-16">
          <Fade direction="up" triggerOnce>
            <h1 className="text-5xl font-extrabold text-blue-800 mb-6 text-shadow-xl transform transition-all duration-500 ease-in-out">
              Our Customers
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed opacity-80">
              Some of our corporate customers who are working with us currently
              are the following
            </p>
          </Fade>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-12 text-center">
          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={ZMH}
                alt="ZMP"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                Zhihapu manfacturing PLC
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={AME}
                alt="AME"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                Alphasol Modular Energy PLC
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={NCL}
                alt="NBP"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                NCL Business PLC
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={STP}
                alt="STP"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                Selina Trading PLC
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={SIP}
                alt="SIP"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                Saturn international PLC
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={JTP}
                alt="JTP"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                JoyTech PLC
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={HIH}
                alt="HIH"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                Hilton International Hotel
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={GFIP}
                alt="GFI"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                Green Field International PLC
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={HIAP}
                alt="HIAP"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                Hela Indochine Apparel PLC at Hawassa Industry Park
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={LAPTP}
                alt="LPT"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                Luxury & Popular Trading PLC
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={ECAA}
                alt="ECAA"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                Ethiopian Civil Avation Authority
              </h3>
            </div>
          </Fade>

          <Fade direction="up" triggerOnce>
            <div className="border-2 border-blue-500 rounded-lg p-3 bg-white  rounded-3xl shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 duration-500 ease-in-out p-8 flex flex-col items-center justify-center">
              <img
                src={ATIE}
                alt="ATIE"
                className="w-32 h-32 mb-4 object-contain"
              />
              <h3 className="text-xl font-semibold text-blue-800">
                Asmere Tegegn Import & Export
              </h3>
            </div>
          </Fade>
        </div>
      </section>

      <Discuss />
      <Footer />
    </>
  );
}
